import { createFileRoute, redirect } from '@tanstack/react-router'
import EntityExploration from '@migrate/components/navigator/exploration/EntityExploration'
import { z } from 'zod'

export const Route = createFileRoute('/_auth/entity/$entityId/_breadcrumbs/exploration')({
  component: RouteComponent,
  validateSearch: z.object({
    viewMode: z.literal('edit').optional(),
  }),
  beforeLoad: ({ context: { scopedEnablements, scope } }) => {
    if (!scopedEnablements.for(scope).hasStandardEnablement('Exploration', 'READ')) {
      throw redirect({
        from: Route.fullPath,
        to: '..',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  const { entity } = Route.useRouteContext()
  return <EntityExploration entityDetail={entity} />
}
